import * as React from "react";
import Svg, { Path } from "react-native-svg";
const Wait = (props) => (
  <Svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Path
      d="M11.9951 2C6.48345 2 1.99903 6.49219 1.99902 12.0038C1.99903 17.5155 6.48344 21.9999 11.9951 21.9999C17.5068 21.9999 21.999 17.5155 21.999 12.0038C21.999 6.49219 17.5068 2 11.9951 2ZM11.9971 5.99994C12.1284 5.99934 12.2585 6.0246 12.3801 6.07434C12.5016 6.12408 12.6122 6.19729 12.7054 6.2898C12.7986 6.3823 12.8727 6.49239 12.9234 6.61356C12.9742 6.73474 13.0005 6.86465 13.001 6.99604L12.999 11.3808L16.8291 13.6464C16.9427 13.7131 17.042 13.8016 17.1213 13.9067C17.2006 14.0119 17.2583 14.1318 17.2912 14.2593C17.324 14.3869 17.3313 14.5198 17.3127 14.6502C17.2941 14.7807 17.2498 14.9061 17.1826 15.0195C17.1154 15.1326 17.0265 15.2315 16.9211 15.3102C16.8156 15.389 16.6957 15.4462 16.5681 15.4785C16.4406 15.5108 16.3079 15.5176 16.1777 15.4985C16.0475 15.4794 15.9224 15.4348 15.8095 15.3672L11.4853 12.8145C11.336 12.7251 11.2125 12.5983 11.1272 12.4465C11.0419 12.2948 10.9977 12.1233 10.999 11.9492L11.0009 6.99615C11.0021 6.73229 11.1074 6.47949 11.294 6.29291C11.4806 6.10633 11.7333 6.00098 11.9971 5.99994Z"
      fill="#2195F2"
    />
  </Svg>
);
export default Wait;
